import { AxiosError } from "axios";
import { useEffect, useMemo, useState } from "react";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";

import { resetPassword } from "../../../services";
import { getIsIpDomain } from "../../../utils";

import { CheckIcon } from "../../../../assets";
import { Copyright, Pagewrapper } from "../../components";
import { PDLTypography } from "../../components/dna";
import ResetPasswordForm from "../../components/global/_resetPasswordForm";

import "./index.scss";

const ResetPassword = (props: any) => {
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState("");

  const isIpDomain = getIsIpDomain();

  const token = useMemo(
    () => new URLSearchParams(window.location.search).get("token"),
    [],
  );

  const handleResetPassword = async (password: string) => {
    setError("");

    if (!token) {
      setError("O link de redefinição é inválido ou expirou.");
      return;
    }

    try {
      setLoading(true);
      await resetPassword(token, password);
      setSuccess(true);
    } catch (error) {
      const err = error as AxiosError<{ message: string }>;

      setError(
        err.response?.data?.message || "Não foi possível redefinir sua senha.",
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!isIpDomain) {
      window.location.href = "/";
      return;
    }

    if (!token) {
      setError("O link de redefinição é inválido ou expirou.");
    }
  }, [isIpDomain, token]);

  return (
    <Pagewrapper {...props}>
      <Container fluid className="pdl_page_reset_password">
        <Row className="h-100">
          <Col sm={6} className="h-100 pdl_page_reset_password_column_left">
            <Container className="h-100 d-flex flex-column align-items-center justify-content-between">
              <Row />

              <Row className="pdl_page_reset_password_form_container">
                <Col>
                  {success ? (
                    <div className="reset_password_success">
                      <div className="reset_password_success_icon">
                        <CheckIcon />
                      </div>

                      <div className="d-grid gap-4 mb-4">
                        <PDLTypography display size="md" weight="semibold">
                          Senha redefinida!
                        </PDLTypography>

                        <PDLTypography size="md">
                          Sua senha foi alterada com sucesso. Agora você já pode
                          acessar sua conta utilizando a nova senha.
                        </PDLTypography>
                      </div>

                      <button
                        className="btn w-100 mb-4"
                        onClick={() => (window.location.href = "/entrar")}
                      >
                        Ir para o login
                      </button>
                    </div>
                  ) : (
                    <>
                      <ResetPasswordForm
                        onSubmit={handleResetPassword}
                        loading={loading}
                      />

                      {error && <p className="form_error mt-3">{error}</p>}
                    </>
                  )}
                </Col>
              </Row>

              <Row className="w-100">
                <Col className="py-3 justify-self-stretch">
                  <Copyright />
                </Col>
              </Row>
            </Container>
          </Col>

          <Col
            sm={6}
            className="h-100 pdl_page_reset_password_column_right d-none d-sm-block"
          >
            <Container className="h-100 p-0 m-0 d-flex flex-column align-items-center justify-content-center">
              <Row>
                <Col className="pdl_page_reset_password_column_right_contents p-0 m-0 text-center d-grid gap-5">
                  <img
                    alt="Plataforma LEX"
                    className="pdl_page_reset_password_image_plataforma rounded"
                    src="/images/generic/plataforma_lex.png"
                  />

                  <div className="d-grid gap-2">
                    <PDLTypography size="xl" variant="light" weight="medium">
                      Boas-vindas à Plataforma LEX
                    </PDLTypography>

                    <PDLTypography size="md" variant="light" weight="medium">
                      Sua fonte central de pesquisa jurídica, com conteúdos
                      confiáveis e atualizados.
                    </PDLTypography>
                  </div>
                </Col>
              </Row>
            </Container>
          </Col>
        </Row>
      </Container>
    </Pagewrapper>
  );
};

export default ResetPassword;
